// src/components/StatsSection.tsx
export default function StatsSection() {
  const stats = [
    { value: "1M+", label: "Leads Processed" },
    { value: "15K+", label: "Doors Managed" },
    { value: "$2.5M", label: "New Leases signed" },
  ];

  return (
    <section className="bg-[#f9fafb] py-16">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-2xl sm:text-4xl  text-gray-800 mb-12">
          Our numbers speak for themselves.
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="text-green-500 text-4xl font-bold">
                {stat.value}
              </div>
              <div className="text-gray-600 mt-2 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
